import { useAppTheme } from '@droplet-tech-code/core-elements/module/theme';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { SupportRequestListItemResponse } from '@naus-code/naus-admin-types';
import { useCallback, useMemo, useState } from 'react';

import { useItemSeparatorComponent } from '~/components/FlatList/FlatList.Common';

import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

import { supportRequestApi } from '../SupportRequests.api';
import { ProvisionalRequestsListHeader } from './ProvisionalRequests.ListHeader';
import { FlatList } from '~/components/FlatList/FlatList';
import { SearchBar } from '@droplet-tech-code/core-elements/module/ui/Search/Search';
import { RefreshControl } from 'react-native-gesture-handler';
import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { useGetAuthUser } from '~/screens/Auth/Auth.Context';
import { SupportRequestListItemComponent } from '../SupportRequest.ListItem';

export interface ProvisionalRequestListProps {
  onPress: (item: SupportRequestListItemResponse) => void;
  id?: string;
}

export const ProvisionalRequestListNative = () => {
  const navigate = useAppNavigation();
  return (
    <ProvisionalRequestList
      onPress={(item) => {
        navigate.navigate('SupportRequest-Item', {
          id: item.id,
        });
      }}
    />
  );
};

export const ProvisionalRequestList = (props: ProvisionalRequestListProps) => {
  const { spacing } = useAppTheme();
  const { currentUser } = useGetAuthUser();
  const [stateData, setStateData] = useState<SupportRequestListItemResponse[]>([]);

  const { data, isLoading, refetch, isFetching } =
    supportRequestApi.useGetProvisionalRequestsOpenQuery(
      {
        adminUserId: currentUser?.uid || '',
        sortBy: 'dateOpenedSR',
      },
      {
        skip: !currentUser,
        pollingInterval: 2 * 60 * 1000,
      },
    );

  const currentSupportReqId = props.id || '';
  const renderItem = useCallback(
    (supportRequest: SupportRequestListItemResponse) => {
      return (
        <SupportRequestListItemComponent
          selected={currentSupportReqId === supportRequest.id}
          key={supportRequest.id}
          supportRequest={supportRequest}
          onPress={() => {
            props.onPress(supportRequest);
          }}
        />
      );
    },
    [currentSupportReqId],
  );

  const ItemSeparatorComponent = useItemSeparatorComponent();
  const searchData = useMemo(() => data?.supportRequests || [], [data]);

  return (
    <VStack flex={1}>
      <VStack>
        <ProvisionalRequestsListHeader refetch={refetch} isLoading={isLoading} />
        <SearchBar
          inputContainerStyle={[{ backgroundColor: 'white' }]}
          data={searchData}
          deps={[searchData]}
          onSearch={(filteredData) => {
            setStateData(filteredData);
          }}
        />
        <Divider />
      </VStack>
      <FlatList
        scrollEnabled
        refreshControl={
          <RefreshControl refreshing={isFetching} onRefresh={() => refetch()} />
        }
        contentContainerStyle={[
          {
            paddingTop: spacing[2.5],
          },

          isNativeMobile && { paddingHorizontal: spacing[2] },
        ]}
        feedback={translate('supportRequests.emptySupportRequest')}
        isLoading={isLoading}
        data={stateData}
        simple
        renderItem={renderItem}
        onPressItem={(v) => {
          props.onPress(v);
        }}
        ItemSeparatorComponent={ItemSeparatorComponent}
      />
    </VStack>
  );
};
